import { createSlice } from "@reduxjs/toolkit";
import VwKurumsozlesmeDTO from "src/models/Islemler/SozlesmeIzleme/VwKurumsozlesmeDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface ISozlesmeIzlemeSlice {
    open: boolean;
    openDialog: "ozet" | "detay";
    activeRow: VwKurumsozlesmeDTO;
};

export const SozlesmeIzlemeSlice = createSlice<ISozlesmeIzlemeSlice, MapReducerPayloads<ISozlesmeIzlemeSlice, {
    setOpen: boolean;
    setOpenDialog: "ozet" | "detay";
    setActiveRow: VwKurumsozlesmeDTO;
}>>({
    name: "sozlesmeIzleme",
    initialState: {
        open: false,
        activeRow: new VwKurumsozlesmeDTO(),
        openDialog: "detay",
    },
    reducers: {
        setOpen: (state, action) => {
            state.open = action.payload;
        },
        setOpenDialog: (state, action) => {
            state.openDialog = action.payload;
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload
        },
    },
});